<label class="toggle-switch">
  <input
    class="toggle-switch__checkbox"
    type="checkbox"
    [(ngModel)]="isChecked"
    (change)="checkValue(isChecked ? true : false)"
  />
  <span class="toggle-switch__slider toggle-switch__slider--round"></span>
</label>
